import { render } from "./feed.vue?vue&type=template&id=42372275&scoped=true"
import script from "./feed.vue?vue&type=script&lang=js"
export * from "./feed.vue?vue&type=script&lang=js"

import "./feed.vue?vue&type=style&index=0&id=42372275&scoped=true&lang=css"

import exportComponent from "/var/www/mkssg/mkssg/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42372275"]])

export default __exports__